import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as $ from 'jquery'
import 'lazysizes'

import '../src/util/install_sentry'
import '../src/site/searchModal'
import '../src/site/linkChange'
import '../src/site/reform_db/city'
import '../src/site/reform_db/searchFormReset'
import '../src/site/reform_db/txtChange'
import '../src/site/reform_db/redirectByParams'
import '../src/dropDownHover/dropDownHover'
import '../src/goTop/goTop'

import 'Components/site/site_footer/component'
import 'Components/site/site_header/component'
import 'Components/site/site_header_navigation/component'
import 'Components/site/call_to_action_link/component'
import 'Components/site/helpful_widget/component'

import spToggleNav from '../src/spToggleNav/spToggleNav'

$(() => {
  spToggleNav()
})
